import styled from 'styled-components';
import { Avatar } from 'antd';

export const Msg = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;

  &:last-of-type {
    margin: 0;
  }

  ${props => {
      if (props.align === 'right') {
        return `
          flex-direction: row-reverse;
        `
      }
  }}
`;

export const StyledAvatar = styled(Avatar)`
  width: 40px;
  margin-${props => props.margin}: 10px;
  background: #ddd;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
`;

export const MsgBubble = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOwnMessage', 'isSending'].includes(prop),
})`
  max-width: calc(100% - 50px);
  min-width: 200px; /* Ensure minimum width to prevent shrinking */
  flex: 1 1 auto; /* Grow to fill the column so messages aren't needlessly narrow */
  padding: 12px 14px;
  border-radius: 15px;
  background: #ececec;
  transition: all 0.3s ease;
  min-height: 50px; /* Ensure consistent minimum height */
  display: flex;
  flex-direction: column;

  ${props => {
    if (props.isSending) {
      return `
        opacity: 0.7;
        animation: pulse 1.5s ease-in-out infinite;
      `
    }
  }}

  ${props => {
    if (props.isOwnMessage) {
      return `
        background: #7BAD7E;
        color: #fff;
        border-bottom-right-radius: 0;
      `
    }

    return `
      box-shadow: ${props.isUnread ? 'inset 0px 0px 100px 10px rgba(123, 173, 126, 0.3)' : 'none'};
      background: #ececec;
      color: #000;
      border-bottom-left-radius: 0;
    `
  }}

  @keyframes pulse {
    0% { opacity: 0.7; }
    50% { opacity: 1; }
    100% { opacity: 0.7; }
  }
`;

export const MsgInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  min-height: 20px; /* Ensure consistent height for author name and timestamp */
`;

export const MsgInfoName = styled.div`
  margin-right: 10px;
  font-weight: bold;
  flex: 1; /* Allow it to take available space but also shrink */
  overflow: hidden; /* Hide overflow text */
  text-overflow: ellipsis; /* Add ellipsis for truncated text */
  white-space: nowrap; /* Prevent wrapping */
  min-width: 0; /* Allow flex item to shrink below its content size */
  text-align: left; /* Keep text left-aligned */
`;

export const MsgInfoTime = styled.div`
  font-size: 0.85em;
  width: 120px; /* Fixed width instead of min-width */
  text-align: right; /* Right-align the text within the fixed width */
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide any overflow text */
  flex-shrink: 0; /* Prevent shrinking */
`;

export const MsgText = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isOwnMessage',
})`
  hyphens: auto;
  font-size: 13px;
  line-height: 1.5;
  word-break: break-word;

  /* Author-supplied rich text (bold, italics, lists, links) should cascade
     from the wrapper's font-size and line-height. We only force color so
     editor-inlined text colors don't clash with the bubble background
     (green for own messages, light gray otherwise). */
  & * {
    color: ${props => (props.isOwnMessage ? '#fff' : '#000')} !important;
  }

  & p {
    margin: 0 0 6px;
  }

  & p:last-child {
    margin-bottom: 0;
  }

  & .mention-tag {
    font-weight: bold;
    color: inherit !important;
    /* Override the inline background emitted by the editor so mentions
       read correctly inside own-message (green) bubbles. */
    background-color: ${props => (props.isOwnMessage
      ? 'rgba(255, 255, 255, 0.2)'
      : 'rgba(123, 173, 126, 0.15)')} !important;
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-block;
  }
`;

export const ImageWrapper = styled.div`
  width: inherit;
  text-align: center;
  padding: 8px 8px;
`;

export const Image = styled.img`
  width: 68%;
  height: auto;
  cursor: pointer;
`;
